import { appEventTypes } from "common/events/AppEventTarget";

class HideMobileSidebarEvent extends Event{
  constructor() {
    super(appEventTypes.HIDE_MOBILE_SIDEBAR_EVENT);
  }
}

export default HideMobileSidebarEvent;
